import {
  Box,
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { FiAlertCircle } from "react-icons/fi";
import moment from "moment";
import { FaCircle } from "react-icons/fa";
import { isMetaProperty } from "typescript";

import { toast } from "react-toastify";
import { useSetRecoilState, useRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { GRAY, REDMONEDD, VARIANT } from "../../../../constants/colors";
import { goToPixDireto } from "../../../../routes/coordinator";
import VendasDigitadasApi from "../../../../services/vendasDigitadasApi";

export default function ModalSendEmailRequest({
  isOpen,
  setIsOpen,
  token,
}: any) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];

  const onClose = () => {
    setIsOpen(false);
    goToPixDireto(navigate);
  };

  // console.log("token no modal de envio do email", token);

  const [loading, setLoading] = useState(false);

  async function sendEmail() {
    try {
      setLoading(true);
      const response = await VendasDigitadasApi.senEmailWithLinkForPayment(
        token
      );
      setLoading(false);
      toast.success("Link enviado para o e-mail com sucesso!");
      goToPixDireto(navigate);
    } catch (error) {
      console.log("error: ", error);
      toast.error("Não foi possível enviar o e-mail de pagamento!");
    }
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>Venda criada com sucesso!</Text>
            </Flex>
          </ModalHeader>
          <ModalBody display={"flex"} justifyContent={"center"}>
            <Text>
              Deseja enviar um e-mail com o link de pagamento para o cliente?
            </Text>
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              background={VARIANT}
              color={"white"}
              mr={3}
              disabled={loading}
              onClick={() => {
                sendEmail();
                onClose();
              }}
            >
              {loading ? <Spinner /> : `Enviar E-mail`}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
